var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgP(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "19px",
    height: "27px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -103 -19 )"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18.998055485049107 9.336564994036916  C 18.915942085073304 3.9076265268815864  14.85506043850932 -0.02669627070910481  9.294809941434387 0.00013641854615556527  C 9.294809941434387 0.00013641854615556527  0 0.00013641854615556527  0 0.00013641854615556527  L 0 27  L 6.569071870938333 27  L 6.569071870938333 19.274073046759735  C 6.569071870938333 19.274073046759735  9.294809941434387 19.21676219058194  9.294809941434387 19.21676219058194  C 14.637513251852262 19.21676219058194  19.106829078377636 15.310532639933198  18.998055485049107 9.336564994036916  Z M 12.511096656545497 9.478159547073984  C 12.483370053233962 11.259336931162208  11.121566689026519 12.695517450602624  9.403583789014347 12.695517450602624  C 9.403583789014347 12.695517450602624  6.460298531861238 12.695517450602624  6.460298531861238 12.695517450602624  L 6.460298531861238 6.491176795837566  C 6.460298531861238 6.491176795837566  9.431310416161955 6.491176795837566  9.431310416161955 6.491176795837566  C 11.121566816152235 6.491176795837566  12.511096656545497 7.6688879099485865  12.511096656545497 9.478159547073984  Z ",
    fillRule: "nonzero",
    fill: "#d80020",
    stroke: "none",
    transform: "matrix(1 0 0 1 103 19 )"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgP);
export default __webpack_public_path__ + "static/media/p.3708912dc80a787b6c1be5e56b07140d.svg";
export { ForwardRef as ReactComponent };